import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Smoothly scroll to top on every route change (mirrors the design's go()). */
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);
  return null;
}
